import React, {useEffect} from "react";
import {Race} from "../../../schemas/races/racesSchema";
import {Box, IconButton, Menu, MenuItem} from "@mui/material";
import RacesCalendar from "./RacesCalendar";
import RacesList from "./RacesList";
import TuneIcon from '@mui/icons-material/Tune';

interface RaceOverviewProps {
    races: Race[] | undefined;
}

type ViewType = "calendar" | "list" | "both";

const RacesOverviewTable: React.FC<RaceOverviewProps> = ({races}) => {
    const publicRaces = races?.filter(race => race.publishStatus === "PUBLISHED" || race.publishStatus === "ANNOUNCED");

    const [selectedView, setSelectedView] = React.useState<ViewType>(localStorage.getItem("selectedView") as ViewType || "both");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    useEffect(() => {
        localStorage.setItem("selectedView", selectedView);
    }, [selectedView]);

    const handleViewChange = (view: ViewType) => {
        setSelectedView(view);
        setAnchorEl(null);
    }

    return (
        <>
            <Box display="flex" justifyContent="flex-end">
                <IconButton
                    title="Změnit zobrazení"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                >
                    <TuneIcon/>
                </IconButton>
            </Box>

            <Menu
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem
                    onClick={() => handleViewChange("calendar")}
                    selected={selectedView === "calendar"}
                >
                    Kalendář
                </MenuItem>
                <MenuItem
                    onClick={() => handleViewChange("list")}
                    selected={selectedView === "list"}
                >
                    Seznam
                </MenuItem>
                <MenuItem
                    onClick={() => handleViewChange("both")}
                    selected={selectedView === "both"}
                >
                    Obojí
                </MenuItem>
            </Menu>

            {(selectedView === "calendar" || selectedView === "both") && <RacesCalendar races={publicRaces}/>}
            {(selectedView === "list" || selectedView === "both") && <RacesList races={publicRaces}/>}
        </>
    );
}

export default RacesOverviewTable;